export interface NetWorthBridge {
  readonly investments_cents: number;
  readonly cash_cents: number;
  /** Negative when a margin loan is owed. */
  readonly margin_cents: number;
  /** Other debts and anything else, so the lines always add up. */
  readonly other_cents: number;
  readonly net_worth_cents: number;
}

/** The steps from investments to net worth. */
export function buildNetWorthBridge(input: {
  readonly investments_cents: number;
  readonly cash_cents: number;
  readonly margin_cents: number;
  readonly net_worth_cents: number;
}): NetWorthBridge {
  return {
    ...input,
    other_cents:
      input.net_worth_cents -
      input.investments_cents -
      input.cash_cents -
      input.margin_cents,
  };
}

/** Names what makes up the liabilities total, with amounts shown positive. */
export function describeDebts(
  bridge: NetWorthBridge,
  format: (cents: number) => string,
): string {
  const parts = [
    ...(bridge.margin_cents < 0
      ? [`Margin loan ${format(-bridge.margin_cents)}`]
      : []),
    ...(bridge.other_cents < 0
      ? [`other debts ${format(-bridge.other_cents)}`]
      : []),
  ];
  return parts.length > 0 ? parts.join(" + ") : "No debts recorded";
}

/** 2026-05-04 to May 4, 2026. */
export function formatIsoDate(iso: string): string {
  return new Date(`${iso}T12:00:00`).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
